:host {
  display: flex;
  flex-direction: column;
}

.row {
  box-sizing: border-box;
  position: relative;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  gap: 10px;
  width: auto;
  justify-content: space-between;
  margin: 20px 0;
  padding: 20px;
  background-color: var(--color-grey-blue);
  @include text-main;
  font-size: var( --font-size-xs);

  &.first-row {
  }

  a {
    @include link;
  }

  .name {
    h5 {
      @include text-bold();
      @include h5();
      margin: 0;
    }
  }
  .contact {
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 0 10px
  }

  .info {
    .services {
      display: flex;
      float: left;
      flex-wrap: wrap;
      gap: 0 20px;
    }

    .service {
      position: relative;
    }

    .icon {
      &.has-tooltip {
        cursor: pointer;
      }

      &.inactive img {
        opacity: 0.3;
      }
    }

    .tooltip {
      display: none;
      position: absolute;
      left: -106px;
      bottom: 56px;
      z-index: 100;
      opacity: 0;
      transition: opacity .15s linear;
      background-color: var(--color-light-grey);
      line-height: 1.4;
      padding: 1px;
      border: 0;
      border-radius: 0;
      box-shadow: 0 3px 10px var(--color-transparent-black);
      max-width: 250px;
      width: 250px;

      &.visible {
        opacity: 1;
        display: block;
      }

      .tooltip-arrow {
        position: absolute;
        display: block;
        width: 0;
        height: 0;
        left: 50%;
        bottom: -11px;
        margin-left: -11px;
        border: 11px solid transparent;
        border-top-color: var(--color-grey-blue);
        border-bottom-width: 0;
      }

      .tooltip-content {
        padding: 9px 14px;
      }
    }

    .certificate {
      position: absolute;
      top: 0;
      right: 0;
      height: 38px;
      width: auto;
      background-color: white;
      padding: 4px;
    }
  }

  p {
    margin: 0;
    padding: 0;
    line-height: 1.2;
    font-size: var(--font-size-xs);
  }

  a {
    &:hover, &:focus {
      text-decoration: none;
      color: var(--color-red);
    }
  }

  &.show-map {
    .location {
      cursor: pointer;

      &:hover, &:focus {
        text-decoration: none;
        color: var(--color-red);
      }
    }
  }

  .bold {
    @include text-bold;
  }

  &.rsm, &.rep {
    grid-template-columns: 1fr;
    margin: 0;
  }
}

.headline {
  padding: 5px 10px;
  background-color: var(--color-dark-grey);
  color: white;
}

@include media-min-width($breakpoint-l-deprecated) {
  .row {
    grid-template-columns: 1fr 1fr minmax(auto, 40%);
    grid-template-rows: repeat(3, auto);

    .name {
      grid-column: span 3;
      grid-row: 1;
    }

    .location {
      grid-column: 1;
      grid-row: 2;
    }

    .contact {
      grid-column: 2;
      grid-row: 2;
    }

    .info {
      grid-column: 3;
      grid-row: 2 / 4;
      grid-template-rows: repeat(3, auto 1fr);
      align-content: end;
    }

    .maps-link {
      grid-column: 1 / 3;
      grid-row: 3;
    }

    &.rsm {
      grid-template-rows: auto 1fr;
      flex: 1;

      .name, .contact {
        grid-column: 1;
      }
    }
  }
}
